import Constants from 'Constants'
import api from '../index'

const { SERVER_PORTAL_URL } = Constants

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    updateBillingAddress: builder.mutation({
      query: ({ businessId, accountId, body }) => ({
        url: `${SERVER_PORTAL_URL}/api/v1/tenants/${businessId}/accounts/${accountId}/billing-address`,
        method: 'PUT',
        body,
      }),
    }),
    getBillingAddress: builder.query({
      query: ({ businessId, accountId }) => ({
        url: `${SERVER_PORTAL_URL}/api/v1/tenants/${businessId}/accounts/${accountId}/billing-address`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useUpdateBillingAddressMutation, useLazyGetBillingAddressQuery } = extendedApi
